/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import Routing from '@/routes';
import { Alert, HTTPErrorInfoDialog } from '@/components/uikit';
import store from '@/store';
import { initialConfigHooks } from '@/utils/hooks';
import { ErrorBoundaryBugsnag } from '@/plugins';
import { SnackBarProvider } from './store/snackbar/snackbarContext';

const App = () => {
  // FIXME move inside Routing so that hooks can retrieve router data
  // to check if current route need to fetch config or not
  const { loading, midtransClientKey } = initialConfigHooks();

  useEffect(() => {
    const script = document.createElement('script');
    const url = process.env.REACT_APP_MIDTRANS_URL_SCRIPT;
    if (url) script.src = url;
    script.async = true;
    script.setAttribute('data-client-key', midtransClientKey);

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return loading ? null : (
    <Provider store={store}>
      <SnackBarProvider>
        <Router basename="/">
          <HTTPErrorInfoDialog />
          <Alert />
          <Switch>
            <Routing />
          </Switch>
        </Router>
      </SnackBarProvider>
    </Provider>
  );
};

const appWithOption = () => {
  if (process.env.REACT_APP_NODE_ENV === 'PRODUCTION') {
    return (
      <ErrorBoundaryBugsnag>
        <App />
      </ErrorBoundaryBugsnag>
    );
  }
  return <App />;
};

export default appWithOption;
